import { Singleton } from "helper/tools";
import PagoTableCell from "./PagoTableCell";

function CreatePagoTable({
  totalAplicar,
  allItems,
  errorProductosAmount,
  handleAmountChange,
}) {
  //errorOtroAmount
  const signTotalAplicar = Singleton.getInstance().format(totalAplicar);

  let re = errorProductosAmount.includes((e) => {
    return e.length > 0;
  });
  const totalClass = re
    ? { fontWeight: "bold", color: "red" }
    : { fontWeight: "normal", color: "black" };
  return (
    <div className=" d-flex flex-column">
      <table className="table table-hover" style={{ tableLayout: "auto" }}>
        <thead>
          <tr>
            <th
              scope="col"
              style={{
                textAlign: "center",
                width: "10px",
              }}
            >
              #
            </th>
            <th scope="col">Producto</th>
            <th
              scope="col"
              style={{
                textAlign: "center",
                width: "100px",
              }}
            >
              Adeudo Quincenal
            </th>
            <th
              scope="col"
              style={{
                textAlign: "center",
                width: "100px",
              }}
            >
              Adeudo Total
            </th>
            <th
              scope="col"
              style={{
                textAlign: "center",
                width: "140px",
              }}
            >
              Abono
            </th>
          </tr>
        </thead>
        <tbody>
          {allItems?.map((aItem, index) => {
            let aId = aItem.eid;
            if (aId == null) {
              aId = aItem.producto.id;
            }

            console.log(
              `--> Render table buidlROW: ${aItem.productoAbono} index: ${index}`,
            );

            return (
              <PagoTableCell
                key={aId}
                aItem={aItem}
                index={index}
                productoAbono={aItem.productoAbono}
                errorProductosAmount={errorProductosAmount}
                handleAmountChange={handleAmountChange}
              />
            );
          })}
        </tbody>
      </table>
      <div className="d-flex gap-1">
        <span style={{ flex: "1" }}></span>
        <span className="fw-bold text-end" style={{ width: "100px" }}>
          Total:
        </span>
        <span className="text-center" style={{ width: "140px", ...totalClass }}>
          {signTotalAplicar}
        </span>
      </div>
    </div>
  );
}

export default CreatePagoTable;
